import { FilterDropdownProps } from 'antd/lib/table/interface'
import CIMSDateRange from '../../../../../CIMSDateRange'
import { useState } from 'react'
import { Moment } from 'moment'
import { toMoments } from '../../../../../../utils/toMoment'
import ColumnFilterWrapper from './ColumnFilterWrapper'

const ColumnDatePicker: React.FC<FilterDropdownProps> = ({
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
}) => {
  const [, setSearchValue] = useState<[Moment | null, Moment | null] | null>(
    null
  )
  return (
    <ColumnFilterWrapper
      confirm={confirm}
      onOk={() =>
        setSearchValue(toMoments(selectedKeys[0].toString().split(',')) ?? null)
      }
      onReset={() => setSearchValue(null)}
      selectedKeys={selectedKeys}
      clearFilters={clearFilters}
    >
      <CIMSDateRange
        preventClear
        value={
          selectedKeys[0]
            ? toMoments(selectedKeys[0].toString().split(','))
            : null
        }
        onChange={(range) => {
          setSelectedKeys(range ? [range.toString()] : [])
        }}
      />
    </ColumnFilterWrapper>
  )
}

export default ColumnDatePicker
